export const RATES_SET = 'RATES_SET';
